<template>
  <div class="sklib-layout">
    <SklibHeaderVue />
    <main class="sklib-main">
      <router-view />
    </main>
    <SklibFooterVue />
    <el-backtop target=".sklib-main" :right="16" :bottom="8" />
  </div>
</template>

<script>
import SklibHeaderVue from "./sklib-header.vue";
import SklibFooterVue from "./sklib-footer.vue";

export default {
  name: "SklibLayout",
  components: {
    SklibHeaderVue,
    SklibFooterVue,
  },
};
</script>

<style lang="scss" scoped>
.sklib-layout {
  display: flex;
  flex-direction: column;
  height: 100%;

  .sklib-main {
    flex-grow: 1;
    overflow: auto;
  }
}
</style>